import { Clocking } from './clocking.model';
import { ClockIn } from './clock-in.model';
import { ClockInControls } from './clok-in-controls';
import { Product } from './product.model';
import { Operation } from './operation.model';

import { SBSuiteException } from './sbsuite-exception.model';

import moment from 'moment';

import { APP_DI_CONFIG } from '../../../app/app-config.module';
import { Params } from './params.model';
import { THROW_IF_NOT_FOUND } from '@angular/core/src/di/injector';
import { Observable } from 'rxjs';

/**
 * Contiene la configuración de fechas de APP_DI_CONFIG
 */
const DATE_FORMAT = APP_DI_CONFIG;


/**
 * Establece y gestiona el estado de SBSuite
 *
 * @export
 * @class SBSuite
 */
export class SBSuite{

    /**
     * Contiene los parámetros de SBSuite.
     *
     * @type {Params}
     * @memberof SBSuite
     */
    params: Params = new Params();

    /**
     * Contiene el modelo de fichadas.
     *
     * @type {Clocking}
     * @memberof SBSuite
     */
    clocking: Clocking = new Clocking();
    public informe: Observable<any>;
    public informeColumns: Observable<any>;

    /**
     * Contiene el modelo de los controles
     *
     * @type {ClockInControls}
     * @memberof SBSuite
     * @deprecated Eliminar??
     */
    controls: ClockInControls = new ClockInControls();


    /**
     * Crea una instancias de SBSuite.
     * @memberof SBSuite
     */
    constructor(){

    }


    /**
     * Devuelve la fichada automática
     *
     * @type {ClockIn}
     * @memberof SBSuite
     */
    get current(): ClockIn{
        return this.clocking.current;
    }

    /**
     * Establece la fichada automática
     *
     * @memberof SBSuite
     */
    set current(clockIn: ClockIn){
        this.clocking.current = clockIn;
    }

    /**
     * Devuelve la fichada manual
     *
     * @type {ClockIn}
     * @memberof SBSuite
     */
    get manually(): ClockIn{
        return this.clocking.manually;
    }

    /**
     * Establece la fichada manual
     *
     * @memberof SBSuite
     */
    set manually(clockIn: ClockIn){
        this.clocking.manually = clockIn;
    }

    /**
     * Devuelve el operador de la fichada automática actual.
     *
     * @type {string}
     * @memberof SBSuite
     */
    get currentOperator(): string{
        return this.clocking.current.operator;
    }

    /**
     * Devuelve el nombre del operador de la fichada actual.
     *
     * @type {string}
     * @memberof SBSuite
     */
    get currentName(): string{
        return this.clocking.current.name;
    }

    /**
     * Establece el nombre del operador de la fichada actual.
     *
     * @memberof SBSuite
     */
    set currentName(name: string){
        this.clocking.current.name = name;
    }

    /**
     * Devuelve el nombre del operador de la última fichada.
     *
     * @readonly
     * @type {string}
     * @memberof SBSuite
     */
    get lastName(): string{
        return this.clocking.last.name;
    }

    /**
     * Devuelve el nombre del operador de la fichada manual.
     *
     * @type {string}
     * @memberof SBSuite
     */
    get manuallyName(): string{
        return this.clocking.opName;
    }

    /**
     * Establece el nombre del operador de la fichada actual.
     *
     * @memberof SBSuite
     */
    set manuallyName(name: string){
        this.clocking.opName = name;
    }


    /**
     * Establece el operador de la fichada automàtica actual.
     *
     * @memberof SBSuite
     */
    set currentOperator(operator: string){
        this.clocking.current.operator = operator;
    }

    /**
     * Devuelve la orden de fabricación de la fichada automàtica actual.
     *
     * @type {string}
     * @memberof SBSuite
     */
    get currentOF(): string{
        return this.clocking.current.manufacturingOrder;
    }

    /**
     * Establece la orden de fabricación de la fichada automàtica actual.
     *
     * @memberof SBSuite
     */
    set currentOF(of: string){
        this.clocking.current.manufacturingOrder = of;
    }

    /**
     * Devuelve la orden de fabricación de la fichada manual.
     *
     * @type {string}
     * @memberof SBSuite
     */
    get manuallyOF(): string{
        return this.clocking.manually.manufacturingOrder;
    }

    /**
     * Establece la orden de fabricación de la fichada manual.
     *
     * @memberof SBSuite
     */
    set manuallyOF(of: string){
        this.clocking.manually.manufacturingOrder = of;
    }

    /**
     * Devuelve los productos de la fichada automàtica actual.
     *
     * @type {Array<Product>}
     * @memberof SBSuite
     */
    get currentProducts(): Array<Product>{
        return this.clocking.current.products;
    }

    /**
     * Establece los productos de la fichada automàtica actual.
     *
     * @memberof SBSuite
     */
    set currentProducts(products: Array<Product>){
        this.clocking.current.products = products;
    }

    /**
     * Devuelve los productos de la fichada manual actual.
     *
     * @type {Array<Product>}
     * @memberof SBSuite
     */
    get manuallyProducts(): Array<Product>{
        return this.clocking.manually.products;
    }

    /**
     * Establece los productos de la fichada manual actual.
     *
     * @memberof SBSuite
     */
    set manuallyProducts(products: Array<Product>){
        this.clocking.manually.products = products;
    }

    /**
     * Devuelve la operación  de la fichada automàtica actual.
     *
     * @memberof SBSuite
     */
    get currentOperation(): Operation{
        return this.clocking.current.operation;
    }

    /**
     * Establece la operación de la fichada automàtica actual.
     *
     * @memberof SBSuite
     */
    set currentOperation(operation: Operation){
        this.clocking.current.operation = operation;
    }

    /**
     * Devuelve la operación  de la fichada manual actual.
     *
     * @memberof SBSuite
     */
    get manuallyOperation(): Operation{
        return this.clocking.manually.operation;
    }

    /**
     * Establece la operación de la fichada manual actual.
     *
     * @memberof SBSuite
     */
    set manuallyOperation(operation: Operation){
        this.clocking.manually.operation = operation;
    }

    /**
     * Devuelve el operador de la última fichada
     *
     * @type {string}
     * @memberof SBSuite
     */
    get lastOperator(): string{
        return this.clocking.last.operator;
    }

    /**
     * Establece el operador de la última fichada
     *
     * @memberof SBSuite
     */
    set lastOperator(operator: string){
        this.clocking.last.operator = operator;
    }

    /**
     * Devuelve la operación de la última fichada
     *
     * @type {Operation}
     * @memberof SBSuite
     */
    get lastOperation(): Operation{
        return this.clocking.last.operation;
    }

    /**
     * Establece la operación de la última fichada
     *
     * @memberof SBSuite
     */
    set lastOperation(operation: Operation){
        this.clocking.last.operation = operation;
    }

    /**
     * Devuelve el operador de las fichadas manuales
     *
     * @type {string}
     * @memberof SBSuite
     */
    get manuallyOperator(): string{
        return this.clocking.operator;
    }

    /**
     * Establece el operador de las fichadas manuales
     *
     * @memberof SBSuite
     */
    set manuallyOperator(operator: string){
        this.clocking.operator = operator;
    }


    /**
     * Devuelve el filtro de fecha para las fichadas manuales.
     *
     * @memberof SBSuite
     */
    get filterDate(){
        return this.clocking.date;
    }


    /**
     * Devuelve el indice de la fichada del historial seleccionada.
     *
     * @type {number}
     * @memberof SBSuite
     */
    get hIndex(): number{
        return this.clocking.hIndex;
    }

    /**
     * Establece el indice de la fichada seleccionada del historial.
     *
     * @memberof SBSuite
     */
    set hIndex(index: number){
        this.clocking.hIndex = index
    }


    /**
     * Establece el filtro de fecha para las fichadas manuales.
     *
     * @memberof SBSuite
     */
    set filterDate(date: string){
        this.clocking.date = date;
    }

    /**
     * Devuelve las observaciones de la ficada manual.
     *
     * @type {string}
     * @memberof SBSuite
     */
    get manuallyObservations(): string{
        return this.manually.observations;
    }


    /**
     * Establece las observaciones de la fichada manual.
     *
     * @memberof SBSuite
     */
    set manuallyObservations(observations: string){
        this.manually.observations = observations;
    }


    getRequestDate(){
        return moment(this.clocking.date,'L').format('YYYY-MM-DD')
    }


    /**
     * Devuelve el operador de la fichada actual.
     *
     * @returns
     * @memberof SBSuite
     */
    getCurrentOperator(): string{
        return this.getCurrent().operator;
    }

    /**
     * Devuelve los nombres concatenados con ', '
     * de los productos de la fichada actual.
     *
     * @returns {string}
     * @memberof SBSuite
     */
    getCurrentProductsList(): string{
        return this.clocking.current.getProductsList();
    }

    /**
     *  Devuelve el nombre de la operación actual.
     *
     * @returns {string}
     * @memberof SBSuite
     */
    getCurrentOperationName(): string{
        return this.clocking.current.getOperationName();
    }

    /**
     * Devuelve el nombre de la operación de la última fichada.
     *
     * @returns {string}
     * @memberof SBSuite
     */
    getLastOperationName(): string{
        return this.clocking.last.operation.name;
    }

    /**
     * Devuelve la fichada del historia seleccionada.
     *
     * @returns
     * @memberof SBSuite
     */
    getManuallyInHistory(){
        return this.clocking.getManuallyInHistory();
    }

    /**
     * Actualiza la fichada manual al historial.
     *
     * @memberof SBSuite
     */
    setManuallyInHistory(): void{
        return this.clocking.setManuallyInHistory();
    }

    /**
     * Elimina una fichada del historial.
     *
     * @param {number} [index=null] el indice de la fichada
     * @memberof SBSuite
     */
    deleteIndexInHistory(index: number = null): void{
        this.clocking.deleteIndexInHistory(index);
    }




    /**
     *
     *
     * @returns {*}
     * @memberof SBSuite
     * @deprecated: Comprovar si se puede eliminar.
     */
    getCurrentStart(): any{
        return this.clocking.current.getStartTime();
    }


    /**
     *
     * @deprecated: Comprovar si se puede eliminar.
     * @memberof SBSuite
     */
    endCurrent(){
        this.clocking.endCurrent();
    }


    /**
     * Devuelve la fichada actual.
     *
     * @returns {ClockIn}
     * @memberof SBSuite
     */
    getCurrent(): ClockIn{
        return this.clocking.current;
    }

    /**
     * Devuelve la fichada manual.
     *
     * @returns {ClockIn}
     * @memberof SBSuite
     */
    getManually(): ClockIn{
        return this.clocking.manually;
    }


    /**
     * Devuelve los datos de la última fichada.
     *
     * @returns {ClockIn}
     * @memberof SBSuite
     */
    getLast(): ClockIn{
        return this.clocking.last;
    }

    /**
     * Devuelve el historial de fichadas.
     *
     * @returns {Array<ClockIn>}
     * @memberof SBSuite
     */
    getHistory(): Array<ClockIn>{
        return this.clocking.history;
    }


    /**
     * Indica si la fichada actual NO está iniciada
     *
     * @returns {boolean}
     * @memberof SBSuite
     */
    isCurrentEmpty(): boolean{
        return this.getCurrent().isEmpty();
    }

    /**
     * Indica si la ficada actual NO está iniciada
     *
     * @returns {boolean}
     * @memberof SBSuite
     */
    isLastEmpty(): boolean{
        return this.getLast().isEmpty();
    }

     /**
     * Indica si la fichada manual NO está iniciada
     *
     * @returns {boolean}
     * @memberof SBSuite
     */
    isManuallyEmpty(): boolean{
        return this.getManually().isEmpty();
    }



    /**
     * Assigna la última fichada a la actual
     *
     * @memberof SBSuite
     */
    assignLast(): void{
        let current = this.getLast().copy();
        this.clocking.current = current;
    }


    /**
     * Continua la última fichada
     *
     * Devuelve True si no ha habido problemas
     * False en caso contrario
     *
     * @returns {boolean}
     * @memberof SBSuite
     */
    continueLast(): boolean{
        if(!this.isLastEmpty()){
            this.assignLast();
            this.startCurrent();
            return true;
        }
        else console.warn('Last MO is empty');
        return false;
    }

    loadCurrent(): boolean{
        if(!this.isCurrentEmpty()){
            this.startCurrent(this.getCurrent().start); //Inicia al fichada actual
            this.saveCurrentIfStarted(); //Guarda una copia de la fichada actual
            return true;
        }
        else console.warn('Current MO is empty');
        return false;
    }



    /**
     * Inicia la fichada actual
     *
     * @param {string} [date=moment().format('YYYY-MM-DD HH:mm:ss')]
     * @memberof SBSuite
     */
    startCurrent(date: string =  moment().format('YYYY-MM-DD HH:mm:ss')): void{
        this.clocking.startCurrent(date);
    }

    /**
     * Devuelve el tiempo transcurrido de la fichada actual
     * Si se especifica {end}, calcula el tiempo hasta esta fecha
     *
     * @param {string} end
     * @returns {number} El interval de tiempo inicial - final en unix timestamp
     * @memberof Clocking
     */
    getCurrentElapsedTime(end?: string): number{
        return this.clocking.getCurrentElapsedTime(end);
    }

	/**
     * Inicia la lista de OFs interna
     *
     * @param {Array<any>} list
     * @memberof SBSuite
     */
    setInternalListFromResponse(list: Array<any>){
		this.clocking.setInteralMOsFromResponse(list);
    }


    /**
     * Inicial la lista del historial a partir de un JSON de la respuesta http
     *
     * @param {Array<any>} list
     * @returns {Array<ClockIn>} El array del historial
     * @memberof SBSuite
     */
    setHistoryFromResponse(list: Array<any>): Array<ClockIn>{
        return this.clocking.setHistoryFromResponse(list);
    }
    setInformeFromResponse(list: Observable<any>){
      this.informe = list;
      alert("set informe");
      console.log(list);
    }


    /**
     * Devuelve el listado interno de OFs
     *
     * @returns {Array<ClockIn>} El array de fichadas internas.
     * @memberof SBSuite
     */
    getInternalList(): Array<ClockIn>{
        return this.clocking.internal;
    }


    /**
     * Assigna un elemento de la lista interna como fichada actual
     *
     * @param {number} [index=0]
     * @memberof SBSuite
     */
    setInternalAsCurrent(index: number = 0){
        this.clocking.setInternalAsCurrent(index);
    }


    /****************************
     ** Funciones de respuesta **
     ****************************/


    /**
     * Procesa los datos de la respuesta de cambio de operario, entrarOperario, cambiarOf
     * compuesta por un Array(2).
     *  array[0]: fichada actual del operario
     *  array[1]: fichada anterior del operario
     *
     * @param {*} data
     * @memberof SBSuite
     */

    setCurrentLastResponse(code: string = null, data: Array<any>=[], defVals:any = {}): void{
        if(code == null)  throw new Error(SBSuiteException.EXCEPTIONS.CAMBIAR_OPERARIO_NO_CODE);
        if(!Array.isArray(data) )  throw new Error(SBSuiteException.EXCEPTIONS.CAMBIAR_OPERARIO_NO_ARRAY);
        if(data.length < 1) throw new Error(SBSuiteException.EXCEPTIONS.CAMBIAR_OPERARIO_BAD_ARRAY);

        if(data.length == 1){ //Determinar si es fichada actual o última
            if(data[0] === null){
                this.currentOperator = code;
                this.lastOperator = code;
                return;
            }
            if(data[0].id_rt_operario === null) this.getLast().setFromResponse(data[0]);
            else this.getCurrent().setFromResponse(data[0], defVals);

        }
        else{ //Fichadas actual y última
            //Fichada actual
            this.getCurrent().setFromResponse(data[0], defVals);
            //Última fichada
            this.getLast().setFromResponse(data[1]);
        }


        this.lastOperator = code;
        this.currentOperator = code;
        if(!this.currentName) this.currentName = this.lastName;
    }


    /**
     * Resetea todos los datos de fichada.
     *
     * @memberof SBSuite
     */
    resetClocking(){
        this.clocking.reset();
    }

    /**
     * Devuelve los productos relacionados de la fichada actual.
     *
     * @returns {Array<Product>}
     * @memberof SBSuite
     */
    getCurrentRelatedProducts(): Array<Product>{
        return this.clocking.current.getRelatedProducts();
    }

    /**
     * Establece los productos relacionados con la fichada actual.
     *
     * @param {Array<Product>} products El array de productos
     * @memberof SBSuite
     */
    setCurrentRelatedProducts(products: Array<Product>): void{
        this.clocking.current.setRelatedProducts(products);
    }

    /**
     * Devuelve los productos relacionadas de la fichada manual
     *
     * @returns {Array<Product>}
     * @memberof SBSuite
     */
    getManuallyRelatedProducts(): Array<Product>{
        return this.clocking.manually.getRelatedProducts();
    }

    /**
     * Devuelve las operaciones de la fichada manual
     *
     * @param {Array<Product>} products El array de productos
     * @memberof SBSuite
     */
    setManuallyRelatedProducts(operations: Array<Product>): void{
        this.clocking.manually.setRelatedProducts(operations);
    }

    /**
     * Devuelve las operaciones relacionados de la fichada actual.
     *
     * @returns {Array<Operation>}
     * @memberof SBSuite
     */
    getCurrentRelatedOperations(): Array<Operation>{
        return this.clocking.current.getRelatedOperations();
    }

    /**
     * Establece las operaciones relacionadas con la fichada actual.
     *
     * @param {Array<Operation>} operations El array de operaciones
     * @memberof SBSuite
     */
    setCurrentRelatedOperations(operations: Array<Operation>): void{
        this.clocking.current.setRelatedOperations(operations);
    }

    /**
     * Devuelve ñas operaciones relacionadas de la fichada manual.
     *
     * @returns {Array<Operation>}
     * @memberof SBSuite
     */
    getManuallyRelatedOperations(): Array<Operation>{
        return this.clocking.manually.getRelatedOperations();
    }

    /**
    * Devuelve las operaciones relacionadas de la fichada manual.
    *
    * @param {Array<Operation>} operations El array de operaciones.
    * @memberof SBSuite
    */
   setManuallyRelatedOperations(operations: Array<Operation>): void{
       this.clocking.manually.setRelatedOperations(operations);
   }


    /**
     * Devuelve el tiempo de fichada mas grande del historial.
     *
     * @returns {string}
     * @memberof SBSuite
     */
    getMaxHistoryEnd(): string{
        if(!this.clocking.history.length){
            let times =  DATE_FORMAT.startHour.split(':');
            let date = moment(this.filterDate,'L');
            date.set({
                'hour' : parseInt(times[0]?times[0]:'00'),
                'minute'  : parseInt(times[1]?times[1]:'00'),
                'second' : parseInt(times[2]?times[2]:'00')
            });
            return date.format(DATE_FORMAT.dateMask);
        }
        let moments = this.clocking.history.map(item=> moment(item.end,DATE_FORMAT.dateMask));
        return moment.max(moments).format(DATE_FORMAT.dateMask);
    }


    /**
     * Guarda la fichada actual si está iniciada.
     *
     * @returns
     * @memberof SBSuite
     */
    saveCurrentIfStarted(){
        if(!this.current.start) return;
        this.clocking.saveCurrent();
    }

    /**
     * Restablece la fichada actual si está iniciada.
     *
     * @returns
     * @memberof SBSuite
     */
    restoreCurrentIfStarted(){
        if(!this.current.start) return;
        this.clocking.restoreCurrent();
    }

    /**
     * Devuelve el numero de horas total del historial.
     *
     * @returns {string} La suma de horas totales en 2 decimales.
     * @memberof SBSuite
     */
    getHistorySum(): string{
        return this.clocking.getHistorySum().toFixed(2);
    }

    /**
     * Devuelve True si hay que mostrar el input de cantidad en Editar Fichada.
     *
     * @returns {boolean} True si ASKFORQUANTITY está habilitado
     * @memberof SBSuite
     */
    isAFQ(): boolean{
        return this.params.isAFQ();
    }

    getSysLogo(){
        return this.params.getSysLogo();
    }


    /**
     * Devuelve el nombre del operario de la fichada auto.
     *
     * Si no está disponible devuelve el código.
     *
     * @returns
     * @memberof SBSuite
     */
    getCurrentOpName(){
        return this.currentName? this.currentName: this.currentOperator;
    }

    /**
     * Devuelve el nombre del operario de la fichada manual.
     *
     * Si no está disponible devuelve el código.
     *
     * @returns
     * @memberof SBSuite
     */
    getManuallyOpName(){
        return this.manuallyName? this.manuallyName: this.manuallyOperator;
    }

}




// WEBPACK FOOTER //
// ./src/modules/sbsuite/models/sbsuite.model.ts